import { CustomFeedbackOption } from "@kahunmedical/common-configuration/dist/configuration/dialogueOptions";

export type FeedbackInput = {
  freeText?: string;
  positive?: boolean;
  predefinedText?: string;
  customFeedback?: CustomFeedbackOption[];
};
export enum FeedbackStates {
  none,
  positive,
  negative,
}
